import { useCmsData } from '~/App/shared/hooks/useCmsData';
import { MyAuctionsWonPageData } from '~/App/shared/interfaces/store/CmsData';
import {
  MyAuctionsWonPageDocument,
  MyAuctionsWonPageQuery
} from '~/config/generated/graphql';

export const handleMyAuctionsWonPage = ({
  myAuctionsWonPage
}: MyAuctionsWonPageQuery) => {
  return {
    emptyStateText: myAuctionsWonPage?.emptyStateText,
    headline: myAuctionsWonPage?.headline,
    checkoutActiveSubheading: myAuctionsWonPage?.checkoutActiveSubheading,
    checkoutPendingSubheading: myAuctionsWonPage?.checkoutPendingSubheading,
    checkoutCompletedText: myAuctionsWonPage?.checkoutCompletedText,
    checkoutCallbackText: myAuctionsWonPage?.checkoutCallbackText,
    checkoutClosedText: myAuctionsWonPage?.checkoutClosedText,
    checkoutExpiryNoticeText: myAuctionsWonPage?.checkoutExpiryNoticeText,
    helpText: myAuctionsWonPage?.helpText,
    footerContactText: myAuctionsWonPage?.footerContactText,
    cancellation: {
      terms: myAuctionsWonPage?.cancellationTerms,
      buttonText: myAuctionsWonPage?.cancellationButtonText,
      availableText: myAuctionsWonPage?.cancellationAvailableText,
      requestSentTitle: myAuctionsWonPage?.cancellationRequestSentTitle,
      requestSentText: myAuctionsWonPage?.cancellationRequestSentText,
      closedText: myAuctionsWonPage?.cancellationClosedText,
      modal: {
        title: myAuctionsWonPage?.cancellationModalTitle,
        body: myAuctionsWonPage?.cancellationModalBody,
        consentLabel: myAuctionsWonPage?.cancellationModalConsentLabel,
        submitText: myAuctionsWonPage?.cancellationModalSubmitText,
        cancelText: myAuctionsWonPage?.cancellationModalCancelText
      },
      confirmation: {
        title: myAuctionsWonPage?.cancellationConfirmationTitle,
        body: myAuctionsWonPage?.cancellationConfirmationBody,
        closeText: myAuctionsWonPage?.cancellationConfirmationCloseText
      }
    },
    kvdHelperUrl: myAuctionsWonPage?._editingUrl
  };
};

export const useMyAuctionsWonPageCmsData = () =>
  useCmsData<MyAuctionsWonPageQuery, MyAuctionsWonPageData>({
    storeKey: 'myAuctionsWonPage',
    query: MyAuctionsWonPageDocument
  });
